import DraftTimesheetLogLayout from "../../layout";
import { getLastNDays } from "@/lib/utils";
import { useMemo } from "react";
import { TimesheetHeaderTitle } from "@/modules/timesheet/components/header";
import { DAYS_TO_SHOW, TITLE } from "./constants";
import TimesheetDraftByDay from "./_Day_row";

export default function DraftTimesheetLogWeek() {
  const dateKeys = useMemo(() => getLastNDays(DAYS_TO_SHOW), []);

  return (
    <DraftTimesheetLogLayout
      headerContent={<TimesheetHeaderTitle>{TITLE}</TimesheetHeaderTitle>}
    >
      {dateKeys.map((dateKey) => (
        <TimesheetDraftByDay key={dateKey} date={dateKey} />
      ))}
    </DraftTimesheetLogLayout>
  );
}
